import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider, Switch, Tooltip, TableCell, TextField, Typography, withStyles, InputAdornment, Checkbox } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import icFilter from '../../assets/ic_filter.png';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import api from '../api';
import CloseImage from '../../assets/ic_close.png';
import { format } from 'date-fns';
import ic_detail from '../../assets/ic_detail.png';
import { FormGroup } from '@material-ui/core';
import Loader from 'react-loader-spinner'
import CustomDate from '../components/customDate';
import PopUpDetailHistoryReservasi from './PopUpDetailHistoryReservasi';
import { useHistory } from 'react-router';
import ic_downloadFile from '../../assets/ic_downloadFile.png';
import ReactExport from 'react-data-export';
import axios from 'axios';
import Constant from '../../library/Constant';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

export default function RiwayatReservasi(props) {
    const history = useHistory()
    const [dataTable, setDataTable] = useState([])
    const [validFrom, setValidFrom] = useState(null)
    const [validTo, setValidTo] = useState(null)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [dataCount, setDataCount] = useState(10)
    const [loading, setLoading] = useState(false)
    const [popUpFilter, setPopUpFilter] = useState(false)
    const [listDokter, setListDokter] = useState([])
    const [dokter, setDokter] = useState([])
    const [listPoli, setListPoli] = useState([])
    const [poliklinik, setPoliklinik] = useState([])
    const [tglMulai, setTglMulai] = useState(null)
    const [tglSelesai, setTglSelesai] = useState(null)
    const [namaPasien, setNamaPasien] = useState("")
    const [namaUser, setNamaUser] = useState("")
    const [idReservasi, setIdReservasi] = useState("")
    const [opsiPembayaran, setOpsiPembayaran] = useState([])
    const [status, setStatus] = useState([])
    const [reservasiVia, setReservasiVia] = useState([])
    const [reason, setReason] = useState("")
    const [noAntri, setNoAntri] = useState("")
    const [dataDetail, setDataDetail] = useState(null)
    const [emergency, setEmergency] = useState(null)
    const [jadwalPeriksa, setJadwalPeriksa] = useState(null)
    const [idDokter, setIdDokter] = useState(null)
    const [intent, setIntent] = useState(null)
    const [visibleDetail, setVisibleDetail] = useState(false)

    const [multiDataSet, setMultiData] = useState([])
    const [download, setDownload] = useState(false)

    const [errorTglSelesai, setErrorTglSelesai] = React.useState(false);
    const [texterrorTglSelesai, setTextErrorTglSelesai] = React.useState(null);

    const [visiblePopUp, setVisiblePopUp] = useState(false)
    const [tglMulaiDownload, setTglMulaiDownload] = React.useState(null);
    const [tglSelesaiDownload, setTglSelesaiDownload] = React.useState(null);

    const [listStatus, setListStatus] = useState([
        { id: 1, value: 'Book' },
        { id: 2, value: 'Reschedule' },
        { id: 3, value: 'Check-In' },
        { id: 4, value: 'Cancel' },
        { id: 5, value: 'Done' },
        { id: 6, value: 'Hold' },
    ])

    const [listReservasi, setListReservasi] = useState([
        { id: 0, value: 'Sistem Lainnya' },
        { id: 1, value: 'Mobile' },
        { id: 2, value: 'Web Admin' },
        { id: 3, value: 'Kiosk' },
    ])

    const [listPayment, setListPayment] = useState([
        { id: 1, value: 'Umum' },
        { id: 2, value: 'Asuransi/Jaminan' },
        { id: 3, value: 'BPJS' },
    ])

    useEffect(() => {
        props.setShowNotif(true)
        getData(page, limit, dokter, poliklinik, tglMulai, tglSelesai, namaPasien, opsiPembayaran, idReservasi, noAntri, status, reservasiVia, reason, false)
        getDataDokter()
        getProfile()
        getDataPoliklinik()
    }, [])

    const onDownload = async () => {
        setLoading(true)
        const start = format(new Date(tglMulaiDownload), 'yyyy-MM-dd')
        const end = format(new Date(tglSelesaiDownload), 'yyyy-MM-dd')
        const filter = {
            appointment_date: {
                start,
                end
            }
        }
        const body = JSON.stringify(filter)
        const res = await api.create('REPORT').getAppointmeentByDate(body)
        console.log(res, 'hehe')
        if (res.status !== 200 || res.data.type == "application/json") {
            // alert("data tidak ditemukan!")
            const blob = new Blob([res.data], { type: 'application/json' });
            const reader = new FileReader();

            reader.onload = function (event) {
                const text = event.target.result;
                const json = JSON.parse(text);
                alert(json.data)
            };
            reader.readAsText(blob);
            setLoading(false)
        } else {
            var fileURL = window.URL.createObjectURL(
                new Blob([res.data])
            );
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", `Report Appointment ${format(new Date(tglMulaiDownload), 'dd-MM-yyyy')} - ${format(new Date(tglSelesaiDownload), 'dd-MM-yyyy')} - oleh ${namaUser} - pada ${format(new Date(), 'dd-MM-yyyy HH:mm:ss')}.xlsx`);
            document.body.appendChild(fileLink);

            fileLink.click();
            setVisiblePopUp(false)
            setLoading(false)
        }
    }


    const getDataPoliklinik = () => {
        api.create().getListMasterPoli().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.map((item) => {
                        if (item.deleted_at === null) {
                            data.push(item)
                        }
                    })
                    setListPoli(data)
                    forceUpdate()
                }

            }
        })
    }

    

    const getProfile = () => {
        api.create().getProfile().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setNamaUser(response.data.data.fullname)
                }
            }
        })
    }


    const getDataDokter = () => {
        api.create().getListDokter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.map((item) => {
                        if (item.deleted_at === null) {
                            data.push(item)
                        }
                    })
                    setListDokter(data)
                    forceUpdate()
                }

            }
        })
    }

    const handleFilter = () => {
        if (tglMulai !== null && tglSelesai === null) {
            console.log("tes");
            setErrorTglSelesai(true)
            setTextErrorTglSelesai("Tanggal Selesai wajib diisi")
        } else {
            getData(page, limit, dokter, poliklinik, tglMulai, tglSelesai, namaPasien, opsiPembayaran, idReservasi, noAntri, status, reservasiVia, reason, true)
        }
    }

    const handleSeeDetail = ({ rowData }) => {
        console.log(rowData);
        const id = rowData[rowData.length - 4]
        // console.log(id);
        const emergency = {
            "doctor_schedule_id": rowData[rowData.length - 1],
            "doctor_schedule_detail_id": rowData[rowData.length - 2],
        }
        api.create().getDetailReservasiDokter(id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setDataDetail(response.data.data)
                    setEmergency(emergency)
                    setJadwalPeriksa(rowData[7])
                    setIdDokter(rowData[rowData.length.length - 3])
                    setIntent('list')
                    setVisibleDetail(true)
                }
            }
        })
    };

    const getData = (a, b, c, d, e, f, g, h, i, j, k, l, m, fromFilter) => {
        let page = a ? `&page=${a}` : ''
        let limit = b ? `&per_page=${b}` : ''
        let dokter = []
        let poli = []
        let tglMulai = e ? `"start":"${format(new Date(e), 'yyyy-MM-dd')}"` : ''
        let tglSelesai = f ? `"end":"${format(new Date(f), 'yyyy-MM-dd')}"` : ''
        let filterDate = tglMulai == "" && tglSelesai == "" ? '' : `&date_filter={"appointment_date": {${tglMulai}, ${tglSelesai}}}`
        let pasien = g !== "" ? `,"patient_name":"${g}"` : ''
        let noAntri = j !== "" ? `,"queue_number":"${j}"` : ''
        let reason = m !== "" ? `,"reasons":"${m}"` : ''
        let opsiPembayaran = []
        let status = []
        h.length > 0 &&
            h.map((item) => {
                opsiPembayaran.push(item.id)
            })
        c.length > 0 &&
            c.map((item) => {
                dokter.push(item.id)
            })
        d.length > 0 &&
            d.map((item) => {
                poli.push(item.id)
            })
        k.length > 0 &&
            k.map((item) => {
                status.push(item.id)
            })
        let idReservasi = i !== "" ? `,"booking_id":${i}` : ''
        let param = `filter={"is_history":1${opsiPembayaran.length > 0 ? `,"payment_option":[${opsiPembayaran}]` : ''}${dokter.length > 0 ? `,"doctor_id":[${dokter}]` : ''}${status.length > 0 ? `,"status":[${status}]` : ''}${poli.length > 0 ? `,"polyclinic_id":[${poli}]` : ''}${pasien}${idReservasi}${noAntri}${reason}}${page}${limit}${filterDate}`
        console.log(param);
        api.create().getReservasiDokterFilter(param).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true && response.data.data != null) {
                    let data = []
                    response.data.data.sort((a, b) => b.doctor_schedule_date - a.doctor_schedule_date).map((item, index) => {
                        let arr = [
                            item.doctor_schedule_date,
                            item.doctor_schedule_date,
                            item.booking_id,
                            item.payment_option_name,
                            item.polyclinics_name,
                            item.doctor_name,
                            item.patient_name,
                            item.patient_phone,
                            item.queue_number || "",
                            item.doctor_schedule_time,
                            item.appointment_status_name,
                            item.reservation_from,
                            item.appointment_reasons || "",
                            item.appointment_id,
                            item.appointment_id,
                            item.doctor_id,
                            item.doctor_schedule_detail_id,
                            item.doctor_schedule_id,
                        ]
                        data.push(arr)
                    })
                    setDataCount(response.data.total_data)
                    setDataTable(data)
                    setPopUpFilter(false)
                    forceUpdate()
                } else if (fromFilter) {
                    setDataCount(0)
                    setDataTable([])
                    setPopUpFilter(false)
                    forceUpdate()
                    // alert("Mohon maaf, data yang anda cari tidak ditemukan!")
                }

            }
        })
    }

    const updateDateRange = (a, b) => {
        // console.log(a, b);
        const c = dataTable.filter((item) => {
            return Number(format(new Date(item[0]), 'yyyyMMdd')) >= Number(a) && Number(format(new Date(item[0]), 'yyyyMMdd')) <= Number(b)
        });
        forceUpdate()

    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const columns = [
        {
            name: "doctor_schedule_date",
            label: "Tanggal",
            options: {
                sort: true,
                filter: true,
                filterType: 'custom',
                resetFilter: () => {
                    console.log('masuk');
                },
                onFilterChange: (columnChanged, filterList) => {
                    console.log(`onFilterChange columnChanged: ${columnChanged}`);
                    console.log(filterList);
                },
                filterOptions: {
                    names: [],
                    logic(age, filters) {
                        if (filters[0] && filters[1]) {
                            return age < filters[0] || age > filters[1];
                        } else if (filters[0]) {
                            return age < filters[0];
                        } else if (filters[1]) {
                            return age > filters[1];
                        }
                        return false;
                    },
                    display: (a, b, c, d, e, f) => (
                        <div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    margin="normal"
                                    label="Tgl. Reservasi Awal"
                                    format="dd/MM/yyyy"
                                    clearable
                                    value={validFrom}
                                    maxDate={new Date().setDate(new Date().getDate() - 1)}
                                    onChange={(date) => {
                                        console.log(a, b, c, d, e, f);
                                        setValidFrom(date)
                                        if (validTo === null) {
                                            setValidTo(date)
                                        }
                                        date === null ? updateDateRange(format(new Date(), 'yyyyMMdd'), validTo === null ? format(new Date(date), 'yyyyMMdd') : format(new Date(validTo), 'yyyyMMdd')) : updateDateRange(format(new Date(date), 'yyyyMMdd'), validTo === null ? format(new Date(date), 'yyyyMMdd') : format(new Date(validTo), 'yyyyMMdd'))
                                        // forceUpdate()
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    ),
                },
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 77, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "doctor_schedule_date",
            options: {
                display: false,
                filterType: 'custom',
                filterOptions: {
                    names: [],
                    logic(age, filters) {
                        if (filters[0] && filters[1]) {
                            return age < filters[0] || age > filters[1];
                        } else if (filters[0]) {
                            return age < filters[0];
                        } else if (filters[1]) {
                            return age > filters[1];
                        }
                        return false;
                    },
                    display: (filterList, onChange, index, column) => (
                        <div>
                            <FormGroup column>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        margin="normal"
                                        clearable
                                        label="Tgl. Reservasi Akhir"
                                        format="dd/MM/yyyy"
                                        maxDate={new Date().setDate(new Date().getDate() - 1)}
                                        minDate={validFrom === null ? new Date() : validFrom}
                                        value={validTo}
                                        onChange={(date) => {
                                            setValidTo(date)
                                            if (validFrom === null && date !== null) {
                                                setValidFrom(new Date())
                                            }
                                            if (date === null) {
                                                getData(page, limit, dokter, poliklinik, tglMulai, tglSelesai, namaPasien, opsiPembayaran, idReservasi, noAntri, status, reservasiVia, reason, false)
                                                setDataTable(null)
                                            } else {
                                                updateDateRange(validFrom === null ? format(new Date(), 'yyyyMMdd') : format(new Date(validFrom), 'yyyyMMdd'), format(new Date(date), 'yyyyMMdd'))
                                            }
                                            // forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </FormGroup>
                        </div>
                    ),
                }
            }
        },
        {
            name: "booking_id",
            label: "ID Reservasi",
            options: {
                filter: true,
                sort: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', width: 95 }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "payment_option_name",
            label: "Opsi Pembayaran",
            options: {
                sort: true,
                filter: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', width: 135 }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "polyclinics_name",
            label: "Klinik",
            options: {
                sort: true,
                filter: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 170, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "doctor_name",
            label: "Nama Dokter",
            options: {
                sort: true,
                filter: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', width: 150 }}>
                            {val}
                        </div>
                    )
                }
            }
        },

        {
            name: "patient_name",
            label: "Nama Pasien",
            options: {
                sort: true,
                filter: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 170, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "patient_phone",
            label: "No HP Pasien",
            options: {
                sort: true,
                filter: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 120, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "queue_number",
            label: "No Antrian",
            options: {
                sort: true,
                filter: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'center', width: 80, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "doctor_schedule_time",
            label: "Sesi Jadwal",
            options: {
                sort: true,
                filter: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 87, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "appointment_status_name",
            label: "Status",
            options: {
                sort: true,
                filter: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 70, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "reservation_from",
            label: "Reservasi Via",
            options: {
                sort: true,
                filter: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 80, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "appointment_status_reasons",
            label: "Alasan",
            options: {
                sort: true,
                filter: true,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                //         <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 150, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "Detail",
            label: "Detail",
            options: {
                sort: false,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: "13pt", fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button
                                onClick={() => handleSeeDetail(tableMeta)}
                                style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent',
                                    marginRight: 20
                                }}>
                                <img src={ic_detail} style={{ width: 30, height: 30 }} />
                            </button>
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
    ];

    const options = {
        sort: true,
        filterType: 'multiselect',
        fixedHeader: true,
        filter: false,
        search: false,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: limit,
        count: dataCount,
        responsive: 'scrollMaxHeight',
        serverSide: true,
        onFilterChange: (columnChanged, filterList, c, d, e, f, g) => {
            // console.log(columnChanged, filterList, c, d, e, f, g);
            props.setDataReservasi(e === undefined ? [] : e)
            if (columnChanged === null) {
                setDataTable(null)
                setValidFrom(null)
                setValidTo(null)
                getData(page, limit, dokter, poliklinik, tglMulai, tglSelesai, namaPasien, opsiPembayaran, idReservasi, noAntri, status, reservasiVia, reason, false)
            }
        },
        onTableChange: (action, tableState) => {
            // console.log(action, tableState);
            switch (action) {
                case 'changePage':
                    setPage(tableState.page + 1)
                    setLimit(tableState.rowsPerPage)
                    getData(tableState.page + 1, tableState.rowsPerPage, dokter, poliklinik, tglMulai, tglSelesai, namaPasien, opsiPembayaran, idReservasi, noAntri, status, reservasiVia, reason, false)
                    break;
                case 'changeRowsPerPage':
                    setPage(tableState.page + 1)
                    setLimit(tableState.rowsPerPage)
                    getData(tableState.page + 1, tableState.rowsPerPage, dokter, poliklinik, tglMulai, tglSelesai, namaPasien, opsiPembayaran, idReservasi, noAntri, status, reservasiVia, reason, false)
                    break;
                case 'sort':
                    // setLoading(true)
                    sorting(tableState)
                    break;
                default:
                    break;
            }
        }
    };

    const sorting = (tableState) => {
        let arr = dataTable
        console.log(tableState)
        arr.sort(function (a, b) {
            console.log(a[tableState.activeColumn], b[tableState.activeColumn], 'cok')
            if (String(tableState.announceText).includes('descending')) {
                return a[tableState.activeColumn].localeCompare(b[tableState.activeColumn]);
            } else {
                return b[tableState.activeColumn].localeCompare(a[tableState.activeColumn]);
            }
        });
        console.log(dataTable);
        setDataTable(arr)
        forceUpdate()
    };

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 1300, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ paddingTop: 10, position: 'relative', height: props.height - 100, overflow: 'auto' }}>
            {loading && (loadingComponent)}
            <div style={{ position: 'absolute', left: 10, top: 25, zIndex: '10', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <button onClick={() => setPopUpFilter(true)} style={{ height: 36, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none', padding: '0 3vw' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img style={{ width: 16, height: 16, marginRight: 7 }} src={icFilter} />
                        <Typography style={{ fontSize: 14, margin: 'auto', margin: '0 3px', color: 'white' }}>Filter Data</Typography>
                    </div>
                </button>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <LightTooltip title={"Download Data"} arrow>
                        <div style={{ cursor: 'pointer', display: 'flex' }} onClick={() => setVisiblePopUp(true)}>
                            <img src={ic_downloadFile} style={{ width: 30, height: 30, marginRight: 16 }} />
                        </div>
                    </LightTooltip>
                </div>
            </div>
            <div style={{ minHeight: 600, width: props.width - (props.open === true ? 370 : 120), marginTop: '8vh' }}>
                {!loading && (
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            columns={columns}
                            data={dataTable}
                            options={options}
                        />
                    </MuiThemeProvider>
                )}
            </div>

            {popUpFilter && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white">
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 30, borderTopLeftRadius: 30, backgroundColor: '#f5f5f5' }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18, }}>Filter</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setPopUpFilter(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ backgroundColor: '#f5f5f5', padding: '20px' }}>
                            <div className="column-1">
                                <CustomDate
                                    value={tglMulai}
                                    clearable={true}
                                    label={"Tanggal Mulai"}
                                    maxDate={new Date()}
                                    setValue={(date) => {
                                        setTglMulai(date)
                                        tglSelesai === null && setTglSelesai(date)
                                    }}
                                />
                            </div>
                            <div className="column-2">
                                <CustomDate
                                    require={true}
                                    value={tglSelesai}
                                    clearable={true}
                                    label={"Tanggal Selesai"}
                                    minDate={new Date(tglMulai)}
                                    maxDate={new Date()}
                                    error={errorTglSelesai}
                                    helperText={texterrorTglSelesai}
                                    setValue={(date) => {
                                        setTglSelesai(date)
                                        setErrorTglSelesai(false)
                                        setTextErrorTglSelesai(null)
                                    }}
                                />
                            </div>
                            <div className="column-1">
                                <Autocomplete
                                    multiple
                                    options={listDokter}
                                    getOptionLabel={(option) => option.name}
                                    size="small"
                                    onChange={(event, newInputValue) => {
                                        setDokter(newInputValue)
                                    }}
                                    value={dokter}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label="Nama Dokter"
                                        />
                                    }
                                />
                            </div>
                            <div className="column-2">
                                <Autocomplete
                                    multiple
                                    options={listPoli}
                                    getOptionLabel={(option) => option.name}
                                    size="small"
                                    onChange={(event, newInputValue) => {
                                        setPoliklinik(newInputValue)
                                    }}
                                    value={poliklinik}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label="Klinik"
                                        />
                                    }
                                />
                            </div>
                            <div className="column-1">
                                <TextField
                                    style={{ width: '100%' }}
                                    size="small"
                                    label="Nama Pasien"
                                    onChange={(e) => {
                                        setNamaPasien(e.target.value)
                                    }}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                    value={namaPasien}
                                />
                            </div>
                            <div className="column-2">
                                <TextField
                                    style={{ width: '100%' }}
                                    size="small"
                                    label="ID Reservasi"
                                    value={idReservasi}
                                    onChange={(e) => {
                                        setIdReservasi(e.target.value)
                                        forceUpdate()
                                    }}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-1">
                                <TextField
                                    style={{ width: '100%' }}
                                    size="small"
                                    label="No Antrian"
                                    onChange={(e) => {
                                        setNoAntri(e.target.value)
                                    }}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                    value={noAntri}
                                />
                            </div>
                            <div className="column-2">
                                <Autocomplete
                                    multiple
                                    options={listPayment}
                                    getOptionLabel={(option) => option.value}
                                    size="small"
                                    onChange={(event, newInputValue) => {
                                        setOpsiPembayaran(newInputValue)
                                    }}
                                    value={opsiPembayaran}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label="Opsi Pembayaran"
                                        />
                                    }
                                />
                            </div>
                            <div className="column-1">
                                <Autocomplete
                                    multiple
                                    options={listStatus}
                                    getOptionLabel={(option) => option.value}
                                    size="small"
                                    onChange={(event, newInputValue) => {
                                        setStatus(newInputValue)
                                    }}
                                    value={status}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label="Status"
                                        />
                                    }
                                />
                            </div>
                            <div className="column-2">
                                <TextField
                                    style={{ width: '100%' }}
                                    size="small"
                                    label="Alasan"
                                    onChange={(e) => {
                                        setReason(e.target.value)
                                    }}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                    value={reason}
                                />
                            </div>
                        </div>

                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div onClick={() => {
                                    setDokter([])
                                    setPoliklinik([])
                                    setTglMulai(null)
                                    setTglSelesai(null)
                                    setNamaPasien("")
                                    setIdReservasi("")
                                    setOpsiPembayaran([])
                                    setStatus([])
                                    setReservasiVia([])
                                    setNoAntri("")
                                    setReason("")
                                    forceUpdate()
                                }} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Reset</Typography>
                                </div>
                                <div onClick={(e) => handleFilter()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Filter</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {visibleDetail && (
                <PopUpDetailHistoryReservasi
                    data={dataDetail}
                    emergency={emergency}
                    jadwalPeriksa={jadwalPeriksa}
                    idDokter={idDokter}
                    intent={intent}
                    onClose={() => setVisibleDetail(false)}
                />
            )}



            {visiblePopUp && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 800 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18, whiteSpace: 'nowrap' }}>Download Appointment</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ width: '100%', alignSelf: 'center', padding: 0, maxWidth: 'inherit' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisiblePopUp(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '20px 50px' }}>
                            <div className="column-1">
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="tanggal mulai"
                                            label="Tanggal Mulai"
                                            required={true}
                                            format="dd/MM/yyyy"
                                            // maxDate={new Date()}
                                            // maxDate={tglSelesaiDownload && tglSelesaiDownload}
                                            value={tglMulaiDownload}
                                            clearable={true}
                                            onChange={(date) => {
                                                setTglMulaiDownload(date)
                                                tglSelesaiDownload === null && setTglSelesaiDownload(date)
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%', margin: 0 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            <div className="column-2">
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="tanggal selesai"
                                            label="Tanggal Selesai"
                                            required={true}
                                            value={tglSelesaiDownload}
                                            clearable={true}
                                            format="dd/MM/yyyy"
                                            // minDate={new Date(tglMulai)}
                                            // maxDate={new Date()}
                                            minDate={tglMulaiDownload && tglMulaiDownload}
                                            onChange={(date) => {
                                                setTglSelesaiDownload(date)
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%', margin: 0 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div style={{ height: 32, width: 145, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} onClick={onDownload} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Download</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
